import zenObservable from 'zen-observable';
export var Observable = zenObservable;
//# sourceMappingURL=zenObservable.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-link-dedup/~/zen-observable-ts/lib/zenObservable.js
// module id = 348
// module chunks = 0